(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-chips"] && !Shopify.designMode) return;
  try {
    class CollectionChipsNav extends HTMLElement {
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;

    connectedCallback() {
      const toggle = this.querySelector('.collection-chips__toggle');
      const list = this.querySelector('.collection-chips__list');
      const items = this.querySelectorAll('.collection-chips__item');
      if (!toggle || !list || items.length < 3) return;

      this.#resizeObserver = new ResizeObserver(() => this.#check(toggle, list, items));
      this.#resizeObserver.observe(this);

      toggle.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
      });
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
    }

    #check(toggle, list, items) {
      if (window.innerWidth < 750) {
        this.#collapse(toggle);
        return;
      }
      const wraps = items[items.length - 1].offsetTop > items[0].offsetTop;
      if (wraps) {
        list.style.setProperty('--chips-full-height', list.scrollHeight + 'px');
        toggle.removeAttribute('hidden');
      } else {
        this.#collapse(toggle);
      }
    }

    #collapse(toggle) {
      toggle.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('collection-chips-nav')) {
    customElements.define('collection-chips-nav', CollectionChipsNav);
  }
  } catch(e) { console.error(e); }
})();

})();
